import type { GetConversation200AllOf } from './getConversation200AllOf';
import type { GetConversation200AllOfThree } from './getConversation200AllOfThree';

export type GetConversation200 = GetConversation200AllOf & GetConversation200AllOfThree;
